import { useState } from "react";
import Toggle from "@/components/base/Toggle";
import CarWashTab from "./components/CarWashTab";
import HomeCleaningTab from "./components/HomeCleaningTab";
import LaundryTab from "./components/LaundryTab";

type ServiceTab = "car" | "home" | "laundry";

const tabs: { key: ServiceTab; label: string }[] = [
  { key: "car", label: "غسيل سيارات" },
  { key: "home", label: "تنظيف منازل" },
  { key: "laundry", label: "مغاسل ملابس" },
];

export default function Services() {
  const [tab, setTab] = useState<ServiceTab>("car");
  const [receiving, setReceiving] = useState(true);
  const [confirmOpen, setConfirmOpen] = useState(false);

  const handleToggle = (value: boolean) => {
    if (!value) {
      setConfirmOpen(true);
    } else {
      setReceiving(true);
    }
  };

  return (
    <div>
      <div className="flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
        <div>
          <h1 className="text-[28px] font-bold text-ghasla-text-heading">الخدمات والأسعار</h1>
          <p className="mt-1 text-sm text-ghasla-text-primary">
            الأسعار والخدمات اللي تحددها هنا هي اللي العميل يشوفها في التطبيق
          </p>
        </div>

        {/* Receiving toggle */}
        <div className="flex items-center gap-4 rounded-[20px] bg-white p-4 shadow-card">
          <div>
            <p className="text-sm font-semibold text-ghasla-text-heading">استقبال الطلبات</p>
            <p className={`mt-0.5 text-xs ${receiving ? "text-[#27AE60]" : "text-[#E74C3C]"}`}>
              {receiving ? "مفعّل — ظاهر للعملاء" : "متوقف — مختفي من نتائج البحث"}
            </p>
          </div>
          <Toggle checked={receiving} onChange={handleToggle} />
        </div>
      </div>

      {/* Tabs */}
      <div className="mt-6 flex gap-2 overflow-x-auto border-b border-[#E4EFEF] pb-px">
        {tabs.map((t) => (
          <button
            key={t.key}
            type="button"
            onClick={() => setTab(t.key)}
            className={`relative cursor-pointer whitespace-nowrap px-4 pb-3 text-sm transition-colors ${
              tab === t.key ? "font-semibold text-ghasla-text-link" : "text-ghasla-text-secondary hover:text-ghasla-text-link"
            }`}
          >
            {t.label}
            {tab === t.key && (
              <span className="absolute inset-x-0 bottom-0 h-[3px] rounded-full bg-gradient-to-l from-[#0D6E6E] to-[#3CBCB4]" />
            )}
          </button>
        ))}
      </div>

      <div className="mt-6">
        {tab === "car" && <CarWashTab />}
        {tab === "home" && <HomeCleaningTab />}
        {tab === "laundry" && <LaundryTab />}
      </div>

      {/* Stop confirmation inline banner */}
      {confirmOpen && (
        <div className="mt-4 flex flex-col gap-4 rounded-[20px] border border-[#E74C3C]/20 bg-[#FFF5F5] p-5 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex items-start gap-3">
            <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-[#E74C3C]/10 text-[#E74C3C]">
              <i className="ri-error-warning-line text-lg" />
            </span>
            <div>
              <p className="text-sm font-semibold text-ghasla-text-heading">إيقاف استقبال الطلبات</p>
              <p className="mt-0.5 text-sm text-ghasla-text-primary">العملاء مش هيشوفوك في التطبيق. متأكد؟</p>
            </div>
          </div>
          <div className="flex shrink-0 items-center gap-3">
            <button
              type="button"
              onClick={() => {
                setReceiving(false);
                setConfirmOpen(false);
              }}
              className="cursor-pointer whitespace-nowrap rounded-xl bg-[#E74C3C] px-5 py-2.5 text-sm font-semibold text-white hover:opacity-90"
            >
              إيقاف
            </button>
            <button
              type="button"
              onClick={() => setConfirmOpen(false)}
              className="cursor-pointer whitespace-nowrap rounded-xl border border-[#E4EFEF] px-5 py-2.5 text-sm font-medium text-ghasla-text-primary hover:bg-white"
            >
              إلغاء
            </button>
          </div>
        </div>
      )}
    </div>
  );
}